import { Controller } from "@hotwired/stimulus"
import { findItem, addToCart, incrementItem, decrementItem } from "../lib/cart_store"
import { track, SHELF_ADD } from "../lib/analytics"

// Toggles a book's action area between a "Comprar" button and a quantity
// stepper depending on whether it's already in the cart — used by the book
// detail page and the catalog card's quick-view dialog (both share the same
// .bm-actions markup as the original BookmaniaBookView/BookmaniaCatalog modal).
export default class extends Controller {
  static targets = ["buyButton", "qty", "qtyValue", "incrementBtn"]

  static values = {
    id: String,
    title: String,
    author: String,
    price: Number,
    internalCode: Number,
    condition: String,
    imageUrl: String,
    stock: Number,
    genreIds: Array
  }

  connect() {
    this.onCartChanged = () => this.render()
    window.addEventListener("cart:changed", this.onCartChanged)
    this.render()
  }

  disconnect() {
    window.removeEventListener("cart:changed", this.onCartChanged)
  }

  buy() {
    addToCart({
      id: this.idValue,
      title: this.titleValue,
      author: this.authorValue,
      price: this.priceValue,
      internal_code: this.internalCodeValue || null,
      condition: this.conditionValue,
      image_url: this.imageUrlValue || null,
      stock: this.stockValue,
      genreIds: this.genreIdsValue.map(String)
    })
    track(SHELF_ADD, { code: this.internalCodeValue || null, title: this.titleValue })
    window.dispatchEvent(new CustomEvent("toast:push", { detail: { msg: `"${this.titleValue}" adicionado à sua estante` } }))
    window.dispatchEvent(new CustomEvent("cart:book-added", { detail: { source: this.element } }))
  }

  increment() {
    incrementItem(this.idValue)
  }

  decrement() {
    decrementItem(this.idValue)
  }

  render() {
    const item = findItem(this.idValue)

    if (item) {
      this.buyButtonTarget.classList.add("u-hidden")
      this.qtyTarget.classList.remove("u-hidden")
      this.qtyValueTarget.textContent = item.quantity
      this.incrementBtnTarget.disabled = item.quantity >= item.stock
    } else {
      this.buyButtonTarget.classList.remove("u-hidden")
      this.qtyTarget.classList.add("u-hidden")
    }
  }
}
